export const PATH_FRAGMENTS = {
  DASHBOARD: 'dashboard',

  AUTH: {
    BASE: 'auth',
    LOGIN: 'login',
  },

  CUSTOMER: {
    BASE: 'customer',
    LIST: 'list',
    DETAIL: 'detail/:customerUUID/:seasonUUID'
    // Agrega aquí más subrutas si lo necesitas
  },

  POST: {
    BASE: 'post',
    POST_FEED: 'post-feed',
    // Agrega aquí más subrutas si lo necesitas
  },

  CONFIG: {
    BASE: 'config',
    GP: 'gp',
    SEASON: 'season',
    NOTIFICATION: 'notification',
    // Agrega aquí más subrutas si lo necesitas
  },
};
